
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "xmlns:a": "http://ns.adobe.com/AdobeSVGViewerExtensions/3.0/",
    "x": "0px",
    "y": "0px",
    "width": "104px",
    "height": "104px",
    "viewBox": "0 0 104 104",
    "enable-background": "new 0 0 104 104",
    "xml:space": "preserve"
  },
  "children": [
    {
      "tag": "defs"
    },
    {
      "tag": "rect",
      "attrsMap": {
        "display": "none",
        "fill": "#F2F2F2",
        "width": "104",
        "height": "104"
      }
    },
    {
      "tag": "rect",
      "attrsMap": {
        "id": "_x3C_切片_x3E__36_",
        "display": "none",
        "fill": "none",
        "width": "104",
        "height": "104"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "fill": "#E8BF3C",
        "d": "M51.288,26.691c0-5.33-4.52-9.691-10.043-9.691H18.089c-5.523,0-10.043,4.361-10.043,9.691\r\n\tc0,5.328,4.52,9.688,10.043,9.688h23.155C46.768,36.38,51.288,32.02,51.288,26.691z"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "fill": "#FBD54D",
        "d": "M85.956,25.66H8v53.372C8,84.516,12.52,89,18.043,89h67.913C91.479,89,96,84.516,96,79.032V35.628\r\n\tC96,30.146,91.479,25.66,85.956,25.66z"
      }
    }
  ]
})
    }
  